module.exports = __webpack_public_path__ + "static/media/U1-T2-2-3d.46644dfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-3d.svg
// module id = 551
// module chunks = 0